// app/javascript/controllers/reminder_controller.js
import { Controller } from "@hotwired/stimulus"
import JustValidate from "just-validate"

export default class extends Controller {
    static targets = ["form"]

    connect() {
        this.form = this.hasFormTarget ? this.formTarget : this.element

        // JustValidate rules
        this.validator = new JustValidate(this.form, { validateBeforeSubmitting: true })
        this.validator
            .addField("#parent_first_name", [{ rule: "required", errorMessage: "First name is required" }])
            .addField("#email", [
                { rule: "required", errorMessage: "Email is required" },
                { rule: "email", errorMessage: "Enter a valid email address" }
            ])
            .addField("#child_first_name", [{ rule: "required", errorMessage: "Child’s first name is required" }])
            .addField("#date", [{ rule: "required", errorMessage: "Birthday is required" }])

        // Gender (single select)
        const gender = this.form.querySelector("select[name='gender'], #gender")
        if (gender) {
            this.validator.addField(gender, [
                { rule: "required", errorMessage: "Gender is required" }
            ])
        }

        // Explicit reCAPTCHA render
        this.widgetEl = document.getElementById("reminder-recaptcha")
        this.widgetId = null

        const tryRender = () => {
            if (window.grecaptcha?.render && this.widgetEl && this.widgetId == null) {
                this.widgetId = grecaptcha.render(this.widgetEl, {
                    sitekey: this.widgetEl.dataset.sitekey,
                    size: "invisible",
                    badge: "bottomright",
                    callback: () => this.onCaptchaSuccess()
                })
            } else if (this.widgetId == null) {
                setTimeout(tryRender, 50)
            }
        }
        tryRender()

        // Reset before Turbo snapshot
        this.beforeCache = () => {
            if (this.widgetId != null && window.grecaptcha?.reset) {
                try { grecaptcha.reset(this.widgetId) } catch (_) {}
            }
        }
        document.addEventListener("turbo:before-cache", this.beforeCache)
    }

    disconnect() {
        document.removeEventListener("turbo:before-cache", this.beforeCache)
        this.validator?.destroy()
    }

    async submit(e) {
        e.preventDefault()
        const valid = await this.validator.revalidate().catch(() => false)
        if (!valid || !this.form.checkValidity()) {
            this.form.classList.add("was-validated")
            return
        }
        if (this.widgetId != null && window.grecaptcha?.execute) {
            try { grecaptcha.reset(this.widgetId) } catch (_) {}
            grecaptcha.execute(this.widgetId)
        } else {
            this.showLoader()
            this.form.submit()
        }
    }

    onCaptchaSuccess() {
        this.showLoader()
        this.form.submit()
        if (this.widgetId != null && window.grecaptcha?.reset) {
            try { grecaptcha.reset(this.widgetId) } catch (_) {}
        }
    }

    showLoader() {
        this.application
            .getControllerForElementAndIdentifier(this.form, "form-loader")
            ?.showLoader()
    }
}